<template>
  <div>
    <div class="container body-container">
      <system-notice-message
        v-if="systemNoticeMessageActive"
        :collapsable="systemNoticeMessageSubBody !== ''"
        :type="systemNoticeMessageType"
      >
        <div slot="title">{{ systemNoticeMessageTitle }}</div>
        <span slot="body">
          <strong>{{ systemNoticeMessageBody }}</strong>
        </span>
        <div slot="sub-body">
          <p>
            <em v-html="systemNoticeMessageSubBody" />
          </p>
        </div>
      </system-notice-message>
      <page-heading>
        <div slot="title">Run a new report</div>
      </page-heading>
      <companies-search></companies-search>
    </div>
  </div>
</template>

<script>
import PageHeading from '@/components/app/PageHeading';
import CompaniesSearch from '@/components/companies/panels/CompaniesSearch';
import SystemNoticeMessage from '@/components/usercomms/SystemNoticeMessage';
import Axios from '@/packages/axios/Axios';

export default {
  components: {
    CompaniesSearch,
    PageHeading,
    SystemNoticeMessage,
  },
  created() {
    Axios.get('/v1/system_notice_message')
      .then((response) => {
        this.systemNoticeMessageActive = response.data.system_notice_message_active;
        this.systemNoticeMessageBody = response.data.system_notice_message_body;
        this.systemNoticeMessageSubBody = response.data.system_notice_message_more_information;
        this.systemNoticeMessageTitle = response.data.system_notice_message_title;
        this.systemNoticeMessageType = response.data.system_notice_message_type;
      })
      .catch((e) => {
        console.log('system notice');
        this.systemNoticeMessageActive = false;
        this.systemNoticeMessageBody = '';
        this.systemNoticeMessageSubBody = '';
        this.systemNoticeMessageTitle = '';
        this.systemNoticeMessageType = '';
        if (e.response) {
          switch (e.response.status) {
            case 401:
              this.$router.push('/error/401');
              break;
            case 403:
              this.$router.push('/error/403');
              break;
            case 404:
              this.$router.push('/error/404');
              break;
            default:
              this.$router.push('/error/unknown');
          }
        }
      });
  },
  data() {
    return {
      systemNoticeMessageActive: false,
      systemNoticeMessageBody: '',
      systemNoticeMessageSubBody: '',
      systemNoticeMessageTitle: '',
      systemNoticeMessageType: '',
    };
  },
  beforeMount(){
    // if (!localStorage.getItem('access_token')) {
    //   this.$router.push('/');
    // }
  }
};
</script>
